/*! Copyright (c) 2024, XAPP AI */
import { FormWidgetTheme, FormWidgetAppChannelInput } from "generated/graphql";

import { cloneDeep } from "lodash";

import { getApiUrl } from "./getApiUrl";
import { invertColor } from "./color";


const BASE_THEME: FormWidgetTheme = {
    accentColor: "#012b54",

    backgroundColor: "#f3f8fb",

    headerBackgroundColor: "#012b54",
    headerTextColor: "#b7c5d1",

    primaryButtonColor: "#ea6539",
    primaryButtonTextColor: "#b7c5d1",
    secondaryButtonColor: "#d567cc",
    secondaryButtonTextColor: "#b7c5d1",

    text: {
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        color: "rgba(0, 0, 0, 0.87)",
        fontSize: "1rem"
    },
    dropdown: {
        backgroundColor: "#ffffff",
        color: "#000000",
        fontSize: "1rem"
    },
    checkbox: {
        backgroundColor: "#ffffff",
        color: "#000000",
        fontSize: "1rem"
    },
    chips: {
        backgroundColor: "#c4dced",
        backgroundColorSelected: "#6e7ae1",
        color: "#ffffff",
        colorSelected: "#000000",
        fontSize: "0.875em"
    },
    date: {
        backgroundColor: "#ffffff",
        backgroundColorSelected: "#a21a1a",
        color: "#000000",
        fontSize: "1rem"
    },
    card: {
        backgroundColor: "#ffffff",
        color: "#000000",
        fontSize: "1rem"
    },
    sideButton: {
        backgroundColor: "#d8412a",
        color: "#ffffff",
        fontSize: "1.5rem",
        minLength: "200px",
        postion: "LEFT",
        top: "50%"
    }
}


/**
 * Generates a default theme for the form widget
 *
 * @param accentColor
 * @returns
 */
export function buildDefaultFormTheme(accentColor?: string): FormWidgetTheme {
    if (!accentColor) {
        return BASE_THEME;
    }

    return generateDefaultTheme(BASE_THEME, accentColor);
}

function generateDefaultTheme(BASE_THEME: FormWidgetTheme, accentColor: string): FormWidgetTheme {
    const theme = cloneDeep(BASE_THEME);

    // TODO Fix this. Something is wrong. Go to town Picasso
    theme.accentColor = accentColor;
    theme.headerBackgroundColor = accentColor;

    // const darkerAccentColor = darkenColor(accentColor, 20);
    // const darkAccentColor = darkenColor(accentColor, 30);

    // const lighterAccentColor = darkenColor(accentColor, -20);
    // const lightAccentColor = darkenColor(accentColor, -30);

    // theme.headerBackgroundColor = darkAccentColor;
    // theme.headerTextColor = lightAccentColor;

    // theme.backgroundColor = lightAccentColor;

    // theme.text.color = darkAccentColor;

    // theme.chips.backgroundColor = lighterAccentColor;
    // theme.chips.colorSelected = darkerAccentColor;
    // theme.chips.color = darkAccentColor;
    // theme.chips.colorSelected = lightAccentColor;

    return theme;
}





export interface FormWidgetInput {
    name: string;
    primaryColor: string;
    secondaryColor?: string;
    appId: string;
    sideButtonLabel?: string;
}

export function generateFormWidgetInput(appInput: FormWidgetInput): FormWidgetAppChannelInput {

    const { appId, primaryColor, } = appInput;

    // Generate an inverted color for text
    const textColor = invertColor(primaryColor, true);

    const apiUrl = getApiUrl();

    const sideButtonLabel: string = appInput.sideButtonLabel || "Contact Us";

    const input: FormWidgetAppChannelInput = {
        type: "form-widget",
        name: "Scheduler",
        connection: {
            serverUrl: `${apiUrl}/apps/${appId}/run`
        },
        autoGreeting: "contact us",
        intentId: "LeadGeneration",

        sideButtonLabel,

        theme: {
            accentColor: primaryColor,

            headerBackgroundColor: primaryColor,
            headerTextColor: textColor,

            sideButton: {
                backgroundColor: primaryColor,
                color: textColor,
            },

            chips: {
                backgroundColor: primaryColor,
                color: textColor,
                colorSelected: textColor,
            },
        }
    }

    return input;
};
